















import { Vue, Component } from 'vue-property-decorator'
import store from 'src/assets/store'

@Component
export default class LayoutLogoButton extends Vue {
  state = store.state

  goToHome () {
    this.state.profile === 'PRESENTER' ? this.goToPresenter() : this.goToAttendee()
  }

  goToAttendee () {
    store.setProfile('ATTENDEE')
    this.$route.name !== 'attendee' && this.$router.replace('/attendee/')
  }

  goToPresenter () {
    store.setProfile('PRESENTER')
    this.$route.name !== 'presenter' && this.$router.replace('/presenter/')
  }
}
